// frontend/src/services/adminService.js
import api from './api';

const adminService = {
  // Dashboard stats
  getDashboardStats: async () => {
    try {
      const response = await api.get('/admin/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Get dashboard stats error:', error);
      throw error;
    }
  },
  
  // Google Maps usage
  getGoogleMapsUsage: async () => {
    try {
      const response = await api.get('/admin/google-maps/usage');
      return response.data;
    } catch (error) {
      console.error('Get Google Maps usage error:', error);
      throw error;
    }
  },
  
  // Update Google Maps settings
  updateGoogleMapsSettings: async (settings) => {
    try {
      const response = await api.put('/admin/google-maps/settings', settings);
      return response.data;
    } catch (error) {
      console.error('Update Google Maps settings error:', error);
      throw error;
    }
  },
  
  // Reset Google Maps usage
  resetGoogleMapsUsage: async () => {
    try {
      const response = await api.post('/admin/google-maps/reset');
      return response.data;
    } catch (error) {
      console.error('Reset Google Maps usage error:', error);
      throw error;
    }
  },
  
  // System info
  getSystemInfo: async () => {
    try {
      const response = await api.get('/admin/system/info');
      return response.data;
    } catch (error) {
      console.error('Get system info error:', error);
      throw error;
    }
  }
};

export default adminService;